import { api, AUTH_URL } from './client';

export async function getTenantUsers(tenantId, options = {}) {
  return api.get(`${AUTH_URL}/api/v1/tenants/${tenantId}/users`, options);
}

export async function addUserToTenant(tenantId, email, role, options = {}) {
  return api.post(
    `${AUTH_URL}/api/v1/tenants/${tenantId}/users`,
    { email, role },
    options
  );
}

export async function removeUserFromTenant(tenantId, userId, options = {}) {
  return api.delete(`${AUTH_URL}/api/v1/tenants/${tenantId}/users/${userId}`, options);
}

export async function updateUserRole(tenantId, userId, role, options = {}) {
  return api.put(
    `${AUTH_URL}/api/v1/tenants/${tenantId}/users/${userId}`,
    { role },
    options
  );
}

export async function getAllTenants(options = {}) {
  return api.get(`${AUTH_URL}/api/v1/tenants`, options);
}

export async function createTenant(tenantData, options = {}) {
  return api.post(`${AUTH_URL}/api/v1/tenants`, tenantData, options);
}

// God mode endpoints
export async function assignUserToAnyTenant(email, tenantId, role, options = {}) {
  return api.post(
    `${AUTH_URL}/api/v1/admin/assign-user`,
    { email, tenant_id: tenantId, role },
    options
  );
}

export async function createTenantWithAdmin(tenantId, name, parentTenantId, adminEmail, options = {}) {
  return api.post(
    `${AUTH_URL}/api/v1/admin/create-tenant-with-admin`,
    {
      tenant_id: tenantId,
      name,
      parent_tenant_id: parentTenantId,
      admin_email: adminEmail,
    },
    options
  );
}

export async function getAllUsers(options = {}) {
  return api.get(`${AUTH_URL}/api/v1/admin/users`, options);
}

export async function getTenantsWithCounts(options = {}) {
  return api.get(`${AUTH_URL}/api/v1/admin/tenants`, options);
}

export async function mergeTenants(sourceTenantIds, targetTenantId, options = {}) {
  return api.post(
    `${AUTH_URL}/api/v1/admin/tenants/merge`,
    { source_tenant_ids: sourceTenantIds, target_tenant_id: targetTenantId },
    options
  );
}
